// Ordered bootstrap pipeline. main.ts calls `bootstrap()` and nothing else.
//
// Order rationale:
//   1. initEnv           — fail fast on missing config; nothing downstream can
//                          trust env without this running.
//   2. createAppInstance — Vue app + plugins (so initSentry has an app to
//                          attach to).
//   3. initSentry        — must run before any logger transport that writes to
//                          Sentry. Reads env.
//   4. initLogger        — registers the Sentry transport now that Sentry exists.
//   5. initObservability — registers the active tracer (no-op until OTel is
//                          wired). Runs after Sentry so the two share trace
//                          context, before page-tracking so the first
//                          navigation span is captured.
//   6. initAnalytics     — Mixpanel init + router page-tracking afterEach.
//   7. initWebVitals     — registers Core Web Vitals listeners; harmless if late.
//   8. app.mount         — last, after every observer/transport is wired.

import { initSentry } from '@core/monitoring/sentry'
import { initWebVitals } from '@core/monitoring'
import { initEnv } from './initEnv'
import { initLogger } from './initLogger'
import { initObservability } from './initObservability'
import { initAnalytics } from './initAnalytics'
import { createAppInstance, router } from './initApp'

export const bootstrap = (): void => {
  initEnv()
  const app = createAppInstance()
  initSentry(app, router)
  initLogger()
  initObservability()
  initAnalytics(router)
  initWebVitals()
  app.mount('#app')
}
